module.exports = __webpack_public_path__ + "static/media/whitelogo.20e1b324.png";